import { useState } from "react"
import { CloseIcon } from "./assets/CommonIcons"

export const FiltersBar = ({ filters, setIsDrawerOpen }) => {
    const [activeFilters, setActiveFilters] = useState(filters)

    const handleRemoveFilter = (filter) => {
        activeFilters.filter(filter)
    }

    return (<>
        <nav className="flex items-center w-full px-5 py-5 rounded max-sm:grid shadow-xl">
            <span className="mr-10 w-44 cursor-pointer hover:bg-[#4b6fb9] rounded-lg transition" onClick={() => setIsDrawerOpen(true)}>
                <div className="flex w-full space-x-3 p-3 items-center">
                    <div className="w-20">
                        <svg data-slot="icon" fill="none" stroke-width="1.5" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 0 1-.659 1.591l-5.432 5.432a2.25 2.25 0 0 0-.659 1.591v2.927a2.25 2.25 0 0 1-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 0 0-.659-1.591L3.659 7.409A2.25 2.25 0 0 1 3 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0 1 12 3Z"></path>
                        </svg>
                    </div>

                    <p className="w-full whitespace-nowrap">
                        Filtros de Busca:
                    </p>
                </div>
                <p className="text-slate-300 text-[8pt] p-0 capitalize underline decoration-1 text-center">clique para mudar os filtros</p>
            </span>

            {/* Filters Wrapper */}
            <span className="flex space-x-3 w-full max-sm:overflow-x-scroll max-xl:overflow-x-scroll max-xl:shadow-[inset_0_0_1rem_#0004] p-3 rounded-xl">
                {filters && Object.values(filters).map((filter) => (
                    <p className="flex h-10 items-center px-3 py-1 border rounded-full cursor-pointer hover:bg-[#4556b4]">
                        <span className="whitespace-nowrap">
                            {filter}
                        </span>
                        <span className="p-2 h-full aspect-square max-sm:min-h-10 max-sm:min-w-10">
                            <CloseIcon />
                        </span>
                    </p>
                ))}
            </span>
        </nav >
    </>)
}